import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'fi-side-list-item',
    template: `
        <span title="{{ text }}"
          >{{ text }}
          @if (mobileCounter && mobileCounter() > 0) {
            <span
              class="mobile-counter BrandedBackgroundColor"
              [textContent]="mobileCounter()"
              >
            </span>
          }
          @if (isSuperAdminIconShown) {
            <span class="fas fa-user-secret super-admin-icon"> </span>
          }
        </span>
        `,
    styleUrls: ['./side-list-item.component.scss'],
    standalone: false,
})
export class SideListItemComponent implements OnInit {
    @Input() text;
    @Input() mobileCounter;
    @Input() isSuperAdminIconShown: boolean = false;

    constructor() {}

    ngOnInit() {
        if (!this.mobileCounter) {
            this.mobileCounter = () => '';
        }
    }
}
